import React from "react";
import ApartmentsView from "../../../views/dashboard/apartments";

const Apartments = () => {
  return <ApartmentsView />;
};

export default Apartments;
